var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"markdown-editor",on:{"click":_vm.onClickEditor}},[_c('textarea')])}
var staticRenderFns = []

export { render, staticRenderFns }